module.exports = __webpack_public_path__ + "static/img/howworks.240465c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/howworks.png
// module id = 714
// module chunks = 1